import { GripVertical, Trash2, Asterisk } from "lucide-react";
import { TYPE_META } from "../../constants/formFields";

// Single draggable field card (Bootstrap)
export default function FieldCard({
  field,
  index,
  selected,
  dropHint,
  onSelect,
  onRemove,
  dnd,
}) {
  const Icon = TYPE_META[field.type].icon;
  return (
    <div
      draggable
      onDragStart={dnd.onDragStart(field.id)}
      onDragOver={dnd.onDragOver(index)}
      onDrop={dnd.onDrop(index)}
      onDragEnd={dnd.onDragEnd}
      onClick={() => onSelect(field.id)}
      className={[
        "fb-field-card d-flex align-items-center gap-2 border rounded p-2 mb-2 bg-white",
        selected ? "selected" : "",
        dropHint === "before" ? "fb-drop-before" : "",
        dropHint === "after" ? "fb-drop-after" : "",
      ].join(" ")}
    >
      <GripVertical
        size={16}
        className="text-secondary flex-shrink-0"
        style={{ cursor: "grab" }}
      />
      <span className="fb-icon bg-primary-subtle text-primary flex-shrink-0">
        <Icon size={14} />
      </span>
      <div className="flex-grow-1 min-w-0">
        <div className="fw-semibold small d-flex align-items-center gap-1 text-truncate">
          {field.label || "Untitled"}
          {field.required && <Asterisk size={11} className="text-danger" />}
        </div>
        <div className="d-flex align-items-center gap-2 mt-1">
          <span className="fb-chip bg-primary-subtle text-primary fw-medium">
            {TYPE_META[field.type].label}
          </span>
          <span className="fb-chip bg-light text-secondary fb-mono">
            {field.key}
          </span>
        </div>
      </div>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onRemove(field.id);
        }}
        className="fb-remove text-secondary flex-shrink-0"
      >
        <Trash2 size={16} />
      </button>
    </div>
  );
}
